export type PracticeAppOption = { id: string; name: string };

/**
 * All 12 practice apps, in dashboard order (offense, defense, st, practice),
 * with their names as the drawer and the loading screens show them — in
 * full, never cropped (client 2026-11-03).
 */
export const PRACTICE_APPS: readonly PracticeAppOption[] = [
  { id: "qb", name: "Quarterback" },
  { id: "rb", name: "Running Back" },
  { id: "te", name: "Tight End" },
  { id: "ol", name: "Offensive Line" },
  { id: "wr", name: "Wide Receiver" },
  { id: "lb", name: "Linebacker" },
  { id: "s", name: "Safety" },
  { id: "dl", name: "Defensive Line" },
  { id: "db", name: "Defensive Back" },
  { id: "dc", name: "Defensive Coordinator" },
  { id: "st", name: "Special Teams" },
  { id: "def", name: "Practice" },
];

/**
 * What every wait on the way INTO an app says — in-game's appBootLabel
 * (client 2026-11-03). Opening an app crosses several loading screens in a
 * row (the dashboard's page, the sign-in check, the app's code, its saved
 * data); each asks for this, so one message stays put until the app is
 * usable: "Loading Linebacker" on an app's pages, "Loading the app" off them.
 */
export const appLoadingLabel = (
  pathname: string = typeof window === "undefined" ? "" : window.location.pathname
): string => {
  const id = pathname.split("/")[1] ?? "";
  const app = PRACTICE_APPS.find((a) => a.id === id);
  return app ? `Loading ${app.name}` : "Loading the app";
};
